module.exports = __webpack_public_path__ + "img/icons.ae1c52fe.svg";